import { CalendarIcon } from "@/styles/icons";
import {
    Box,
    Flex,
    Radio,
    RadioGroup,
    Input,
    Text,
} from "@chakra-ui/react";
import { Button, Modal } from "barte-design-system";
import { getEndDateMax, toYMD ,showToast } from "@/utils";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { useReport, useTreasury } from "@/hooks";
import { useEffect, useMemo, useState } from "react";
interface GenerateReportModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCloseSuccess: () => void;
    accountType: string;
}

export function ReportModal({ 
    isOpen, 
    onClose, 
    onCloseSuccess,
    accountType
}: GenerateReportModalProps) {
    const { generateBankingReport } = useReport();
    const { filterState } = useTreasury();
    const { execute, loading } = useAsyncFunction(generateBankingReport);
    const today = toYMD(new Date());
    const [accountTypeForm, setAccountTypeForm] = useState(accountType);
    const [updatedFilterState, setUpdatedFilterState] = useState({  } as any);
    const handleDownloadReport = async () => {
        try {
            const formData = {
                "start_date": updatedFilterState?.startDate,
                "end_date": updatedFilterState?.endDate,
                "account_type": accountTypeForm,
            }
            await execute(formData);
            showToast({
                type: "success",
                message: "Relátorio do extrato enviado para o seu e-mail.",
            });
            onCloseSuccess();
        } catch {
            showToast({
                type: "error",
                message: "Falha ao tentar gerar o relatório.",
            });
        }
    }

    const handleFilterChange = (id: string, value: any) => {
        setUpdatedFilterState(prev => ({
            ...prev,
            [id]: value,
        }))
    }

    useMemo(() => {
        setAccountTypeForm(accountType)
    }, [accountType])

    useEffect(() => {
        setUpdatedFilterState({...filterState})
    }, [filterState])

    return (
        <Modal
            isOpen={isOpen}
            title="Gerar relatórios"
            onClose={onClose}
            footer={{
                primaryButton: {
                    children: "Gerar relatório",
                    onClick: handleDownloadReport,
                    size: "sm",
                    disabled: loading,
                },
                secondaryButton: {
                    children: "Cancelar",
                    onClick: onClose,
                    variant: "outline",
                    size: "sm",
                },
            }}
        >
            <Flex w="100%" direction="column" gap="2">
                <Text>Selecione o tipo de conta: </Text>
                <RadioGroup onChange={(value) => setAccountTypeForm(value)} value={accountTypeForm}>
                    <Flex w="100%" justify="space-between" gap="4">
                        <Flex p="5px 16px" w="236px" h="40px" cursor="pointer" color={accountTypeForm === "CHECKING_ACCOUNT" ? "#DF295D" : ""} border={accountTypeForm === "CHECKING_ACCOUNT" ? "1px solid #DF295D" : "1px solid #BEBEBE"} onClick={() => setAccountTypeForm("CHECKING_ACCOUNT")}>
                            <Radio colorScheme="pink" value="CHECKING_ACCOUNT">Conta corrente</Radio>
                        </Flex>
                        <Flex ml="0" w="236px" h="40px" p="5px 16px" cursor="pointer" color={accountTypeForm === "INVESTMENT_ACCOUNT" ? "#DF295D" : ""} onClick={() => setAccountTypeForm("INVESTMENT_ACCOUNT")} border={accountTypeForm === "INVESTMENT_ACCOUNT" ? "1px solid #DF295D" : "1px solid #BEBEBE"}>
                            <Radio colorScheme="pink" value="INVESTMENT_ACCOUNT">Conta investimento</Radio>
                        </Flex>
                    </Flex>
                </RadioGroup>
                <Text fontSize="1rem">Selecione o período de geração do relatório: </Text>
                <Box mb="4">
                    <Flex align="center" justify="space-between" cursor="pointer" mb="2">
                        <Flex align="center">
                            <Text mr="2"><CalendarIcon size={12} /></Text>
                            <Text>Data</Text>
                        </Flex>
                    </Flex>
                    <Flex mt="2" gap="2">
                        <Input
                            type="date"
                            name="startDate"
                            value={updatedFilterState?.startDate?.toString()}
                            onChange={(e) => {
                                const value = e.target.value || null;
                                handleFilterChange("startDate", value);
                                const newEndMax = getEndDateMax(today, value);
                                if (filterState?.endDate && filterState?.endDate > newEndMax) {
                                    handleFilterChange("endDate", newEndMax);
                                }
                            }}
                            max={today}
                        />
                        <Input
                            type="date"
                            name="endDate"
                            value={updatedFilterState?.endDate?.toString()}
                            onChange={(e) => {
                                const value = e.target.value || null;
                                handleFilterChange("endDate", value);
                            }}
                            _focus={{ border: "1px solid", borderColor: "pink.500" }}
                            max={getEndDateMax(today, filterState?.startDate)}
                            min={filterState?.startDate}
                            isDisabled={!filterState?.startDate}
                        />
                    </Flex>
                </Box>
            </Flex>
        </Modal>
    )
}
